export const ROOT = "ROOT";
export const VARIABLE = "VARIABLE";
export const SECTION = "SECTION";
export const TEXT = "TEXT";
export const COMMENT = "COMMENT";
export const PARTIAL = "PARTIAL";
export const DELIMITER_CHANGE = "DELIMITER_CHANGE";



// WEBPACK FOOTER //
// ./src/node.js